import { render, staticRenderFns } from "./Environmental.vue?vue&type=template&id=de028988&scoped=true&"
import script from "./Environmental.vue?vue&type=script&lang=js&"
export * from "./Environmental.vue?vue&type=script&lang=js&"
import style0 from "./Environmental.vue?vue&type=style&index=0&id=de028988&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de028988",
  null
  
)

export default component.exports